import React, { Component } from "react"
import { Helmet } from "react-helmet"
import Post from "../components/post"

require("../styles/style.scss")
const banner = require("../images/banner.jpg")

class index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            length: 10,
        }
    }

    _renderItems() {
        const { length } = this.state

        const arr = Array.from(new Array(length), (val, index) => index)
        return arr.map(index => (
            <Post
                key={index}
                index={index}
                style={{
                    animationDelay: index + "00ms",
                }}
            />
        ))
        //return items
    }

    render() {
        const { data } = this.props
        const { siteMetadata } = data.site
        console.log(siteMetadata)
        console.log(siteMetadata.banner)
        return (
            <div id="wrapper">
                <Helmet>
                    <title>{siteMetadata.title}</title>
                    <meta
                        name="description"
                        content={siteMetadata.description}
                    />

                    {/* <!-- Open Graph / Facebook --> */}
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={siteMetadata.url} />
                    <meta property="og:title" content={siteMetadata.title} />
                    <meta
                        property="og:description"
                        content={siteMetadata.description}
                    />
                    <meta property="og:image" content={'https://i.imgur.com/g4fM8KBl.jpg'} />
                    {/* <!-- Twitter --> */}
                    <meta
                        property="twitter:card"
                        content="summary_large_image"
                    />
                    <meta property="twitter:url" content={siteMetadata.url} />
                    <meta
                        property="twitter:title"
                        content={siteMetadata.title}
                    />
                    <meta
                        property="twitter:description"
                        content={siteMetadata.description}
                    />
                    <meta property="twitter:image" content={'https://i.imgur.com/g4fM8KBl.jpg'} />
                </Helmet>

                <main>{this._renderItems()}</main>
            </div>
        )
    }
}

export default index

export const query = graphql`
    query SiteTitleQuery {
        site {
            siteMetadata {
                title
                description
                url
                banner
            }
        }
    }
`
